//-----------------------------------
// トップ・swiper
//-----------------------------------


// メインビジュアル・スライドバナー
const mainVisual = new Swiper('.js-mv_slide_swiper', {
  grabCursor: true,
  infinite: true,
  centerMode: false,
  centeredSlides: true,
  slidesPerView: 'auto',
  spaceBetween: 0,
  loop: true,
  autoplay: {
    delay: 4500,
    disableOnInteraction: false, //ユーザー操作しても再稼働
    waitForTransition: false, //ユーザー操作しても再稼働
  }
});


// おすすめのアーティスト
const recommendAirtist = new Swiper('.recommend_artist_swiper', {
  slidesPerView: 'auto',
  spaceBetween: 24,
  grabCursor: true,
  slidesPerView: 2.9,
  breakpoints: {
    750: {
      spaceBetween: 48,
      slidesPerView: 3.5,
    },
  },
  navigation: {
    nextEl: '.recommend_artist_swiper_wrapper .swiper-button-next',
    prevEl: '.recommend_artist_swiper_wrapper .swiper-button-prev',
  },
});


// 実際の商品の画像
let slidable = $('.slide_image_product_swiper .swiper-slide').length > 1; //1枚以上か判定するフラグ

const slideImageProduct = new Swiper('.slide_image_product_swiper', {
  slidesPerView: 'auto',
  // 1枚＝trueでloop停止, 2枚以上＝falseでloop開始
  loop: slidable,
  grabCursor: true,
  infinite: true,
  centerMode: false,
  spaceBetween: 0,
  navigation: {
    nextEl: '.slide_image_product_wrapper .swiper-button-next',
    prevEl: '.slide_image_product_wrapper .swiper-button-prev',
  },
});

if (slidable) {
  // 2枚以上の場合、次へボタン表示
  $('.slide_image_product_button-next, .slide_image_product_button-prev').css('display','flex');
} else {
  // 1枚の場合、次へボタン非表示
  $('.slide_image_product_button-next, .slide_image_product_button-prev').css('display','none');
}



// オリジナル特集コレクション
// 次へボタン・前へボタンをswiperの外に移動するため、それを囲むタグを指定
const productlistSlideAreas = document.querySelectorAll('.j-productlistSlideArea');

productlistSlideAreas.forEach((productlistSlideArea, index) => {
    // 上記タグに対して、複数のswiperがあるため、動的にクラス名を作成
  const className = `j-productlistSlideArea_${index + 1}`;
  productlistSlideArea.classList.add(className);
  
  new Swiper(`.${className} .j-productlistSlide`, {
    grid: {
      fill: 'row',
      rows: 2
    },
    slidesPerGroup: 1,
    slidesPerView: 1.95,
    spaceBetween: 8,
    navigation: {
      nextEl: `.${className} .swiper-button-next`,
      prevEl: `.${className} .swiper-button-prev`,
  },
    breakpoints: {
      750: {
        spaceBetween: 8,
        slidesPerView: 3,
      },
    },
    on: {
      init: function() {
        const productlistSlide = document.querySelector(`.${className} .j-productlistSlide`);
        productlistSlide.classList.add('active');
      }
    }
  });

});
